import { Identifiable } from "./identifiable";
import { Zone, zone } from "./zone";
import { Project, project } from "./project";
import { List, list } from "./list";
import { id } from "./id";

type ListRetrievalResponse = Identifiable<List> & {
  zone: Identifiable<Zone>;
  project: Identifiable<Project>;
};

const listRetrievalResponse: ListRetrievalResponse = {
  ...list,
  project: { ...project, uuid: id },
  uuid: "",
  zone: { ...zone, uuid: id },
};

export type { ListRetrievalResponse };

export { listRetrievalResponse };
